/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/react";
import ja from "date-fns/locale/ja";
import React from "react";
import ReactDatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { CustomHeader } from "./components/CustomHeader";
import {
  detailedSearchCalendarStyles,
  monthButtonStyle,
  monthGridStyle,
  monthPickerContainerStyle,
  monthToggleButtonStyle,
  yearDisplayStyle,
} from "./styles";
import { useThis } from "./useThis";

import type { Props } from "./props";
import type { ReactDatePickerCustomHeaderProps } from "react-datepicker";

registerLocale("ja", ja);

export const DetailedSearchCalendar: React.FC<Props> = (props) => {
  const { maxDate, minDate, selectedDate } = props;
  const {
    currentDate,
    goToNextYear,
    goToPrevYear,
    handleDateChange,
    handleMonthSelect,
    isMonthPicker,
    locale,
    months,
    setIsMonthPicker,
    yearFormatter,
    yearMonthFormatter,
  } = useThis(props);

  if (!isMonthPicker) {
    const renderCustomHeader = (
      reactDatePickerCustomHeaderProps: ReactDatePickerCustomHeaderProps
    ) => {
      const { date, nextMonthButtonDisabled, prevMonthButtonDisabled } =
        reactDatePickerCustomHeaderProps;
      // @typescript-eslint/unbound-method のエラー回避
      const handleClickNext = () => {
        reactDatePickerCustomHeaderProps.increaseMonth();
      };
      // @typescript-eslint/unbound-method のエラー回避
      const handleClickPrevious = () => {
        reactDatePickerCustomHeaderProps.decreaseMonth();
      };
      const dateHeaderCenterContent = (
        <button
          onClick={() => setIsMonthPicker(true)}
          css={monthToggleButtonStyle}
          type="button"
        >
          {yearMonthFormatter(date)}
        </button>
      );
      return (
        <CustomHeader
          centerContent={dateHeaderCenterContent}
          isPreviousEnabled={!prevMonthButtonDisabled}
          isNextEnabled={!nextMonthButtonDisabled}
          onClickNext={handleClickNext}
          onClickPrevious={handleClickPrevious}
        />
      );
    };

    return (
      <div css={detailedSearchCalendarStyles}>
        <ReactDatePicker
          key={locale}
          maxDate={maxDate}
          minDate={minDate}
          selected={selectedDate}
          onChange={handleDateChange}
          locale={locale}
          inline
          renderCustomHeader={renderCustomHeader}
          calendarStartDay={1}
          openToDate={currentDate}
        />
      </div>
    );
  }

  const monthHeaderCenterContent = (
    <div css={yearDisplayStyle}>{yearFormatter(currentDate)}</div>
  );
  return (
    <div css={monthPickerContainerStyle}>
      <CustomHeader
        centerContent={monthHeaderCenterContent}
        onClickPrevious={goToPrevYear}
        onClickNext={goToNextYear}
      />
      <div css={monthGridStyle}>
        {months.map((month, index) => {
          return (
            <button
              key={month}
              onClick={() => handleMonthSelect(index)}
              css={monthButtonStyle}
            >
              {month}
            </button>
          );
        })}
      </div>
    </div>
  );
};
